const Shop = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M28.8773 11.974V8.37361C28.8773 5.40584 25.8329 3 22.0773 3C18.3218 3 15.2773 5.40584 15.2773 8.37361V11.974"
        stroke="#333333"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49727 15.8725C7.64865 14.3371 8.93994 13.1669 10.4828 13.1669H32.9152C34.4312 13.1669 35.7089 14.2978 35.893 15.8026L38.5885 37.8383C38.8072 39.6263 37.412 41.2026 35.6107 41.2026H8.31031C6.53712 41.2026 5.15081 39.6729 5.32479 37.9082L7.49727 15.8725Z"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <path
        d="M15.9805 32.4501H28.9805"
        stroke="#FC8037"
        strokeWidth="3.8"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Shop
